// providers/GoogleAuthProvider.tsx
'use client'

import { useUserQuery } from '@/hooks/react-query/user/use-user'

interface Props {
  children: React.ReactNode
}

export const GoogleAuthProvider = ({ children }: Props) => {
  const { data: user } = useUserQuery()

  if (user) {
    return <>{children}</>
  }

  return (
    <>
      {children}
      {/* <div
        id='g_id_onload'
        data-client_id='1091438153426-290d0bugqt3q9r1j450cpjkc2fvcf795.apps.googleusercontent.com'
        data-login_uri={`${process.env.NEXT_PUBLIC_SITE_URL}auth/callback/google`}
      ></div> */}
    </>
    // <GoogleOAuthProvider
    //   clientId={
    //     '1091438153426-290d0bugqt3q9r1j450cpjkc2fvcf795.apps.googleusercontent.com'
    //   }
    // >
    //   {children}
    //   <GoogleLogin
    //     onSuccess={(credentialResponse) => {
    //       console.log(credentialResponse)
    //     }}
    //     onError={() => {
    //       console.log('Login Failed')
    //     }}
    //     useOneTap
    //     login_uri={`${process.env.NEXT_PUBLIC_SITE_URL}auth/callback/google`}
    //   />
    // </GoogleOAuthProvider>
  )
}
